const Pikaday = require('pikaday');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /*
    |--------------------------------------------------------------------------
    | Pikaday
    |--------------------------------------------------------------------------
    |
    | A refreshing JavaScript Datepicker — lightweight, no dependencies,
    | modular CSS.
    |
    */
    const date = moment().subtract(18, 'years');
    new Pikaday({
        field: $('#datepicker')[0],
        format: 'YYYY-MM-DD',
        yearRange: [1950, date.year()],
        minDate: moment('1950-01-01').toDate(),
        maxDate: date.toDate(),
        showMonthAfterYear: true,
        i18n: {
            months: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre',
            ],
            weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
            weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        },
    });

    // Display plans in the navbar.
    $('.navigation-guest-show').addClass('hidden');

    $('.navigation-toggle').on('click', (e) => {
        e.preventDefault();

        let container = $(e.currentTarget).attr('data-type');

        $('.navigation-guest-plan').addClass('hidden');
        $('.' + container).removeClass('hidden');
    });

    // Select copy from plan when user selected.
    if ($(document).width() > 767) {
        $('.navigation-plan-annual').removeClass('hidden');
    }

    $('.plan-navbar input[type="radio"]').on('click', (e) => {
        let element = $(e.currentTarget).attr('data-type');

        $('.navigation-plan').addClass('hidden');
        $('.' + element).removeClass('hidden');
    });

    /**
     * Display the name of the images attached on contact form.
     */
    $('#contact_image').change(function () {
        var filenames = '';
        for (var i = 0; i < this.files.length; i++) {
            filenames +=
                '<li class="mt-2"><p class="bg-gray-100 border border-gray-200 rounded relative px-3 py-1 inline-block">' +
                this.files[i].name +
                '</p></li>';
        }
        $('#contact_list').html('<ul class="mt-3">' + filenames + '</ul>');
    });

    /**
     * Make inputs accept only numbers.
     */
    $('.input-number').keypress(function (e) {
        if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) return false;

        var maxlength = $(this).attr('maxlength'),
            value = $(this).val().length;

        if (value >= maxlength) return false;
    });

    /**
     * Month type inputs allow 31 days only.
     */
    $('.input-days').keyup(function (e) {
        if ($(this).val() < 1 || $(this).val() > 31) {
            $(this).val(function (index, value) {
                return value.substr(0, value.length - 1);
            });
        }
    });
});
